import { Tabs, theme } from 'antd'
import React, { useEffect, useState } from 'react'
import OverviewDetails from './overview-details'
import EducationTab from './education-tab'
import ExperienceList from './experience-list'
import { useDispatch, useSelector } from 'react-redux'
import { candidateById, getCandidateId, setCandidateId } from '../store/candidate.slice'
import { useLocation, useParams } from 'react-router-dom'
import ProjectTab from './project-tab'
import CandidateOtherDetails from './candidate-other-details'
const CandidateFormTab = () => {
    const { useToken } = theme
    const { token } = useToken()
    const dispatch = useDispatch()
    const [activeTab, setActiveTab] = useState('OVERVIEW')
    const [showEductionForm, setShowEducationForm] = useState(false)
    const [ShowExperienceForm, setShowExperienceForm] = useState(false)
    const [showProjectForm, setShowProjectForm] = useState(false)
    const [showOtherForm, setShowOthreForm] = useState(false)

    const { candidateDetails, isLoading, candidateId } = useSelector((state) => state.candidateSlice)

    const { id } = useParams()
    const pathName = useLocation()
    const getCandidateById = async (id) => {

        try {
            dispatch(candidateById({ id, activeTab }))
        } catch (error) {
            console.log("🚀 ~ getCandidateById ~ error:", error)

        }
    }
    useEffect(() => {
        if (pathName.pathname == "/dashboard/candidates/create") {

            if (candidateId) {
                getCandidateById(candidateId)
            }
        } else if (id) {
            dispatch(setCandidateId(id))
            getCandidateById(id)
        }

    }, [activeTab, id])

    const handleChangeTab = (tab) => {
        setActiveTab(tab);

        if (tab !== "EDUCATION") {
            setShowEducationForm(false);
        }

        if (tab !== "EXPERIENCE") {
            setShowExperienceForm(false);
        }

        if (tab !== "PROJECTS") {
            setShowProjectForm(false);
        }

        if (tab !== "ADDITIONAL") {
            setShowOthreForm(false);
        }
    };


    const tabs = [
        {
            key: 'OVERVIEW',
            label: 'Overview',
            children: <OverviewDetails currantData={candidateDetails} activeTab={activeTab} status={candidateDetails?.status} />,
        },
        {
            key: 'EDUCATION',
            label: 'Education',
            disabled: candidateId == null,
            children: <EducationTab currantData={candidateDetails} activeTab={activeTab} showForm={showEductionForm} setShowForm={setShowEducationForm} candidateId={candidateId} status={candidateDetails?.status} />,
        },
        {
            key: 'EXPERIENCE',
            label: 'Experience',
            disabled: candidateId == null,
            children: <ExperienceList currantData={candidateDetails} activeTab={activeTab} showForm={ShowExperienceForm} setShowForm={setShowExperienceForm} candidateId={candidateId} status={candidateDetails?.status} />,
        },
        {
            key: 'PROJECTS',
            label: 'Projects',
            disabled: candidateId == null,
            children: <ProjectTab currantData={candidateDetails} activeTab={activeTab} showForm={showProjectForm} setShowForm={setShowProjectForm} candidateId={candidateId} status={candidateDetails?.status} />,
        },
    ]


    return (
        <>
            <Tabs
                defaultActiveKey={activeTab}
                activeKey={activeTab}
                onChange={(activeKey) => {
                    // dispatch(changeTab(activeKey))
                    handleChangeTab(activeKey)
                }}
                // rootClassName="profileTabs"
                style={{
                    width: '100%',
                }}
                tabBarStyle={{
                    color: token.colorPalette.textColor.tertiary,
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px',
                    padding: '0px 0px',
                    width: '100%',
                    margin: '0px',
                }}
                tabBarExtraContent={{
                    style: {
                        fontWeight: 'bold',
                    },
                }}
                items={tabs}
                // Customizing the active tab's color
                tabBarActiveColor="blue"
            />
        </>
    )
}

export default CandidateFormTab
